export default {
    // 获取多行省略
    getOverflowEllipsis(str, num = 145) {
        return str.length > num ? `${str.substring(0, num)}...` : str;
    }
};
